var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    className: "icon",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14613 0.286166L0.599758 6.69447C0.414886 6.83124 0.264258 7.01039 0.160065 7.21741C0.055872 7.42444 0.00104182 7.65351 1.23669e-05 7.88611V18.5117C-0.000776677 18.7065 0.0361991 18.8996 0.108823 19.0798C0.181447 19.2601 0.288293 19.424 0.423245 19.5622C0.558197 19.7003 0.718605 19.8101 0.895286 19.8851C1.07197 19.9601 1.26145 19.9989 1.4529 19.9993H5.2133C5.5989 19.9985 5.96844 19.8421 6.24082 19.5643C6.51321 19.2866 6.66618 18.9102 6.66618 18.5178V13.5681H13.3323V18.5147C13.3316 18.7095 13.3685 18.9026 13.4412 19.0829C13.5138 19.2631 13.6206 19.427 13.7556 19.5652C13.8905 19.7034 14.0509 19.8131 14.2276 19.8881C14.4043 19.9632 14.5938 20.002 14.7852 20.0024H18.5456C18.9312 20.0016 19.3008 19.8451 19.5732 19.5674C19.8455 19.2896 19.9985 18.9132 19.9985 18.5208V7.79303C19.9987 7.55936 19.9444 7.32899 19.8401 7.12079C19.7359 6.91259 19.5846 6.7325 19.3988 6.59529L10.8599 0.286166C10.6111 0.101284 10.3111 0.00164795 10.003 0.00164795C9.69497 0.00164795 9.39489 0.101284 9.14613 0.286166Z",
    fill: "#97A7B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.07b8f95c.svg";
export { ForwardRef as ReactComponent };